'use client'

import Sidebar from '../../Components/SideBar';
import HeaderBar from '../../Components/HeaderBar/index';

const  LandingPage = () => {

    return (
      <div className=" m-3 border rounded shadow">
        <div>
          <HeaderBar />          
        </div>
        <div className="d-flex">
          <div className="" style={{width: "20%"}}>
            <Sidebar />            
          </div>
        </div>
      </div>
    );
};

export default LandingPage;